export default __webpack_public_path__ + "static/media/cs_short_logo_white.973da2e6.svg";